module.exports = __webpack_public_path__ + "static/about-figures-5-638e3c09ea7c1c80bcb89fc82bd8d9a9.png";